import { createApp } from "vue";
import App from "./App.vue";
import { setupRouter } from "./router";
import store from "./store";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import dynamicForm from "./custom_lib/dynamic_forms/dynamicformtemplate.vue";
import showForm from "./custom_lib/dynamic_forms/forms.vue";
import editForm from "./custom_lib/dynamic_forms/editForm.vue";
import viewForm from "./custom_lib/dynamic_forms/viewform.vue";
import viewAnotatedForm from "./custom_lib/dynamic_forms/viewAnotatedForm.vue";
import VueApexCharts from "vue3-apexcharts";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import gAuthPlugin from "vue3-google-oauth2";
import formjsfile from "./custom_lib/dynamic_forms/forms.js";
import Pivot from "vue-webdatarocks";
import "webdatarocks/webdatarocks.css";
import en from "./locales/en.json";
import { setupI18n } from "@/i18n";
import { clearStoredSession, hasActiveStoredSession } from "@/Shared/session";
import dateTimeFormats from "./locales/dateTimeFormats.json";
import "clickout-event";
import Flatpickr from "vue-flatpickr-component";
import mitt from "mitt";
import "flatpickr/dist/flatpickr.css";

export const EventBus = mitt();

const i18n = setupI18n({
  datetimeFormats: dateTimeFormats,
  globalInjection: true,
  legacy: false,
  locale: "en",
  fallbackLocale: "en",
  messages: {
    en,
  },
});

async function preloadAppSession() {
  if (!store.getters.authenticated || !store.getters.getIdToken) {
    return;
  }

  if (!hasActiveStoredSession()) {
    clearStoredSession();
    return;
  }

  try {
    const idtoken = store.getters.getIdToken;
    await store.dispatch("setroledata", { idtoken });

    const roledata = store.getters.getRolesData;
    if (roledata) {
      await store.dispatch("loadRolePrivileges", { idtoken, roledata });
    }
  } catch (error) {
    console.error("Unable to preload session data:", error);
    clearStoredSession();
  }
}

function registerGlobalComponents(app) {
  app.component("dynamicform", dynamicForm);
  app.component("showForm", showForm);
  app.component("editForm", editForm);
  app.component("viewForm", viewForm);
  app.component("viewAnotatedForm", viewAnotatedForm);
  app.component("Flatpickr", Flatpickr);
  app.component("apexchart", VueApexCharts);
}

function installPlugins(app) {
  app.use(i18n);
  app.use(formjsfile);
  app.use(Loading);
  app.use(VueApexCharts);
  app.use(store);
  app.use(Pivot);
}

async function bootstrap() {
  const app = createApp(App);
  const router = setupRouter(i18n);

  app.config.globalProperties.$eventBus = EventBus;
  registerGlobalComponents(app);
  installPlugins(app);

  await preloadAppSession();
  app.use(router);
  await router.isReady();
  app.mount("#app");
}

bootstrap().catch((error) => {
  console.error("Failed to bootstrap application:", error);
});
